import { render, staticRenderFns } from "./MemberSent.vue?vue&type=template&id=0512b9f4&scoped=true&"
import script from "./MemberSent.vue?vue&type=script&lang=js&"
export * from "./MemberSent.vue?vue&type=script&lang=js&"
import style0 from "./MemberSent.vue?vue&type=style&index=0&id=0512b9f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512b9f4",
  null
  
)

export default component.exports